import p from "@babel/runtime/helpers/esm/objectSpread2";
import m from "@babel/runtime/helpers/esm/classCallCheck";
import j from "@babel/runtime/helpers/esm/createClass";
import v from "@babel/runtime/helpers/esm/inherits";
import l from "@babel/runtime/helpers/esm/createSuper";
import e from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as h } from "@semcore/utils/lib/core/index";
import u, { sstyled as f, assignProps as y, Component as D } from "@semcore/core";
import S from "react";
import { Box as b } from "@semcore/flex-box";
import x from "@semcore/utils/lib/enhances/resolveColorEnhance";
var k = (
  /*__reshadow_css_start__*/
  (h.insert(
    /*__inner_css_start__*/
    ".___SDivider_10jrd_gg_{display:block}.___SDivider_10jrd_gg_._use_primary_10jrd_gg_{background-color:var(--theme_10jrd, var(--intergalactic-border-primary, #c4c7cf))}.___SDivider_10jrd_gg_._use_primary_10jrd_gg_.___SDivider_10jrd_gg_._theme_default_10jrd_gg_{background:var(--intergalactic-border-primary, #c4c7cf)}.___SDivider_10jrd_gg_._use_primary_10jrd_gg_.___SDivider_10jrd_gg_._theme_invert_10jrd_gg_{background-color:var(--intergalactic-border-primary-invert, #ffffff);opacity:.2}.___SDivider_10jrd_gg_._orientation_horizontal_10jrd_gg_.___SDivider_10jrd_gg_._use_secondary_10jrd_gg_{background-image:linear-gradient(to right,var(--intergalactic-border-primary, #c4c7cf) 3px,transparent 1px);background-size:5px 1px}.___SDivider_10jrd_gg_._orientation_horizontal_10jrd_gg_.___SDivider_10jrd_gg_._use_secondary_10jrd_gg_.___SDivider_10jrd_gg_._theme_default_10jrd_gg_{background:linear-gradient(to right,var(--intergalactic-border-primary, #c4c7cf) 3px,transparent 1px);background-size:5px 1px}.___SDivider_10jrd_gg_._orientation_horizontal_10jrd_gg_.___SDivider_10jrd_gg_._use_secondary_10jrd_gg_.___SDivider_10jrd_gg_._theme_invert_10jrd_gg_{background-image:linear-gradient(to right,var(--intergalactic-border-primary-invert, #ffffff) 3px,transparent 1px);opacity:.2;background-size:5px 1px}.___SDivider_10jrd_gg_._orientation_vertical_10jrd_gg_.___SDivider_10jrd_gg_._use_secondary_10jrd_gg_,.___SDivider_10jrd_gg_._orientation_vertical_10jrd_gg_.___SDivider_10jrd_gg_._use_secondary_10jrd_gg_.___SDivider_10jrd_gg_._theme_default_10jrd_gg_{background-image:linear-gradient(to bottom,var(--intergalactic-border-primary, #c4c7cf) 3px,transparent 1px);background-size:1px 5px}.___SDivider_10jrd_gg_._orientation_vertical_10jrd_gg_.___SDivider_10jrd_gg_._use_secondary_10jrd_gg_.___SDivider_10jrd_gg_._theme_invert_10jrd_gg_{background-image:linear-gradient(to bottom,var(--intergalactic-border-primary-invert, #ffffff) 3px,transparent 1px);opacity:.2;background-size:1px 5px}.___SDivider_10jrd_gg_._orientation_horizontal_10jrd_gg_{width:100%;height:1px}.___SDivider_10jrd_gg_._orientation_vertical_10jrd_gg_{width:1px;height:auto;min-height:100%;align-self:stretch;flex-shrink:0}.___SDivider_10jrd_gg_.__theme_10jrd_gg_._use_primary_10jrd_gg_:not(._theme_default_10jrd_gg_):not(._theme_default_10jrd_gg_){background-color:var(--theme_10jrd)}.___SDivider_10jrd_gg_.__theme_10jrd_gg_._use_secondary_10jrd_gg_:not(._theme_default_10jrd_gg_):not(._theme_default_10jrd_gg_){background-image:linear-gradient(to right,var(--theme_10jrd) 3px,transparent 1px)}",
    "10jrd_gg_"
  ), {
    __SDivider: "___SDivider_10jrd_gg_",
    _use_primary: "_use_primary_10jrd_gg_",
    "--theme": "--theme_10jrd",
    _theme_default: "_theme_default_10jrd_gg_",
    _theme_invert: "_theme_invert_10jrd_gg_",
    _orientation_horizontal: "_orientation_horizontal_10jrd_gg_",
    _use_secondary: "_use_secondary_10jrd_gg_",
    _orientation_vertical: "_orientation_vertical_10jrd_gg_",
    _theme: "__theme_10jrd_gg_"
  })
), r = /* @__PURE__ */ function(g) {
  v(_, g);
  var a = l(_);
  function _() {
    return m(this, _), a.apply(this, arguments);
  }
  return j(_, [{
    key: "render",
    value: function() {
      var d = this.asProps, t, o = b, i = this.asProps, n = i.orientation, s = i.resolveColor, c = i.theme;
      return t = f(this.asProps.styles), /* @__PURE__ */ S.createElement(o, t.cn("SDivider", p({}, y({
        role: "separator",
        "aria-orientation": n,
        "use:theme": s(c)
      }, d))));
    }
  }]), _;
}(D);
e(r, "displayName", "Divider");
e(r, "style", k);
e(r, "enhance", [x()]);
e(r, "defaultProps", {
  use: "primary",
  orientation: "horizontal"
});
const G = u(r);
export {
  G as default
};
